import apartmentSchema from '../services/bimVisualizerApi/schema/apartmentSchema';

export default class Apartment
{
    globalId: string;
    name: string;
    description: string;

    constructor(globalId: string, name: string, description: string = "") {
        this.globalId = globalId;
        this.name = name;
        this.description = description;
    }

    static fromJSON(json: any): Apartment {

        const parsed = apartmentSchema.parse(json);

        const p = new Apartment(parsed.globalId, 
                                parsed.name, 
                                parsed.description ?? "");

        return p;
    }
}